import newOwnersSaga from './sagas'
import slice from './reducer'

export const {
  fetchRequest: newOwnersRequest,
  fetchSuccess: newOwnersSuccess,
  fetchError: newOwnersError,

  updateFilters: newOwnersFilters,
  reset: newOwnersReset,

  fetchApproverHandlerRequest,
  fetchApproverHandlerSuccess,
  fetchApproverHandlerError,

  fetchYearlyApprovalsRequest,
  fetchYearlyApprovalsSuccess,
  fetchYearlyApprovalsError,
} = slice.actions

export default slice.reducer
export { newOwnersSaga }
